import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {useLoaderData, useRouteLoaderData} from '@remix-run/react';
import {useService} from '@cindedi/react-application';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';
import {parsePublicationParams} from '~/domains/research/utilities/parsePublicationParams';
import {
  PublicationsTypePage,
  type PublicationsTypePageData,
} from '~/domains/research/components/PublicationsTypePage';
import type {PublicacoesLayoutLoaderData} from './publicacoes';

export const meta: MetaFunction = function ArtigosMeta({matches}) {
  return seoMeta('publicacoes', {
    title: 'Artigos - Publicações - Cindedi',
    description:
      'Confira os artigos acadêmicos publicados pelo CINDEDI em periódicos nacionais e internacionais sobre desenvolvimento humano e educação.',
  }, matches);
};

export const loader: LoaderFunction = async function ArtigosLoader({request, context: {use}}) {
  const Publication = use('Publication');
  const url = new URL(request.url);
  const params = parsePublicationParams(url.searchParams);

  const result = await Publication.query({...params, type: 'article'});

  return json<PublicationsTypePageData>({
    items: result.items as unknown as Research.PublicPublicationDto[],
    total: result.total,
    page: result.page,
    totalPages: result.totalPages,
  });
};

export default function ArtigosView() {
  const data = useLoaderData() as unknown as PublicationsTypePageData;
  const layoutData = useRouteLoaderData('routes/_public+/publicacoes') as PublicacoesLayoutLoaderData;
  useService('organization/titlebar').setTitle('Publicações — Artigos');

  return <PublicationsTypePage data={data} basePath="/publicacoes/artigos" streams={layoutData.streams} />;
}
